<template>
  <b-container id="OrdersSearchResults">
    <b-row>
      <b-col xs="12" lg="3">
        <orders-menu />
        <div class="mt-4">
          <orders-search-widget-form
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-code="dealerCode"
          />
        </div>
      </b-col>
      <b-col xs="12" lg="9">
        <b-row>
          <h1>{{ format(getContentItem("searchResultsHeading"), SearchKeyword) }}</h1>
        </b-row>
        <b-row>
          <order-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
        <b-row>
          <invoice-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
        <b-row>
          <backorder-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
        <b-row>
          <credit-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapGetters } from "vuex";

  import { stringHelper } from "@/components/mixins";
  import {
    BackorderResults,
    CreditResults,
    InvoiceResults,
    OrderResults,
  } from "@/components/Orders/Search/_ResultsPartials";

  import { OrdersMenu, OrdersSearchWidgetForm } from "@/components";

  export default {
    name: "OrderSearchResults",
    components: {
      BackorderResults,
      CreditResults,
      InvoiceResults,
      OrdersMenu,
      OrderResults,
      OrdersSearchWidgetForm,
    },
    mixins: [stringHelper],
    props: {
      documentNumber: {
        type: String,
        default: "",
      },
      partNumber: {
        type: String,
        default: "",
      },
      dealerCode: {
        type: String,
        default: "",
      },
    },
    data: () => ({
      dealerCodes: [],
    }),
    computed: {
      ...mapGetters(["getContentItem", "user"]),
      SearchKeyword() {
        return this.documentNumber ? this.documentNumber : this.partNumber;
      },
    },
    created() {
      if (this.dealerCode === "ALL") {
        this.dealerCodes = this.user.DealerRange.split(",");
      } else {
        this.dealerCodes = [this.dealerCode];
      }
    },
  };
</script>
